import { render, staticRenderFns } from "./userHead.vue?vue&type=template&id=883ef2ca&scoped=true&"
import script from "./userHead.vue?vue&type=script&lang=js&"
export * from "./userHead.vue?vue&type=script&lang=js&"
import style0 from "./userHead.vue?vue&type=style&index=0&id=883ef2ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883ef2ca",
  null
  
)

export default component.exports